
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.542 6.672q1.048-.056 2.016-.415l.078.135.66 1.141.225.391.781-.451-.225-.39-.66-1.143-.03-.052q.936-.492 1.793-1.287l-.614-.662Q8.582 5.78 6.152 5.78q-2.431 0-4.415-1.84l-.614.661q.815.756 1.7 1.237l-.058.102-.66 1.142-.225.39.782.452.225-.39.66-1.142.099-.172q.958.372 1.994.445V8.418h.902V6.672z","fill-rule":"evenodd","fill":"#FFF"}})])
          )
        }
      }
    